import Tooltip from "@mui/material/Tooltip";
import { useIntl } from "react-intl";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DescriptionIcon from "@mui/icons-material/Description";
import GradeIcon from "@mui/icons-material/Grade";
import ImageIcon from "@mui/icons-material/Image";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import TitleIcon from "@mui/icons-material/Title";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import { QuestionTypeEnum, QuestionTypeIdEnum } from "types/common-types";

const questionTypeConfigs = [
  { value: QuestionTypeEnum.CategoryHeader, id: QuestionTypeIdEnum.CategoryHeaderId, icon: TitleIcon, tooltipKey: "questionTypeCategoryHeader" },
  { value: QuestionTypeEnum.FileUploadDocument, id: QuestionTypeIdEnum.FileUploadDocumentId, icon: DescriptionIcon, tooltipKey: "questionTypeFileUploadDocument" },
  { value: QuestionTypeEnum.FileUploadImage, id: QuestionTypeIdEnum.FileUploadImageId, icon: ImageIcon, tooltipKey: "questionTypeFileUploadImage" },
  { value: QuestionTypeEnum.FileUploadVideo, id: QuestionTypeIdEnum.FileUploadVideoId, icon: VideoFileIcon, tooltipKey: "questionTypeFileUploadVideo" },
  { value: QuestionTypeEnum.MultipleAnswers, id: QuestionTypeIdEnum.MultipleAnswersId, icon: CheckBoxIcon, tooltipKey: "questionTypeMultipleAnswers" },
  { value: QuestionTypeEnum.MultipleChoice, id: QuestionTypeIdEnum.MultipleChoiceId, icon: RadioButtonCheckedIcon, tooltipKey: "questionTypeMultipleChoice" },
  { value: QuestionTypeEnum.Rating, id: QuestionTypeIdEnum.RatingId, icon: GradeIcon, tooltipKey: "questionTypeRating" },
  { value: QuestionTypeEnum.TextQuestion, id: QuestionTypeIdEnum.TextQuestionId, icon: TextFieldsIcon, tooltipKey: "questionTypeText" },
];

const IconQuesionType = ({ value: question }: { value: any }) => {
  const { formatMessage: t } = useIntl();

  const questionType = question.questionType;
  const config = questionTypeConfigs.find(
    (c) => c.value === questionType?.value || c.id === questionType?.id?.toLowerCase()
  );

  if (config) {
    const IconComponent = config.icon;
    return (
      <Tooltip title={t({ id: config.tooltipKey })}>
        <IconComponent />
      </Tooltip>
    );
  }

  return <>{questionType?.name ?? "-"}</>;
};

export default IconQuesionType;
